import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/dramas";

const MARQUEE_TAGS = [
  "豪门黑料",
  "真假千金",
  "重生逆袭",
  "闪婚马甲",
  "悬疑复仇",
  "职场博弈",
  "替嫁宅斗",
  "甜宠下饭",
  "身份反转",
  "旧案曝光",
];

export default function Hero() {
  return (
    <section className="relative isolate overflow-hidden" aria-label="网站首屏">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20theater%20stage%20with%20deep%20crimson%20curtains%20and%20a%20single%20warm%20gold%20spotlight%20beam%20cutting%20through%20atmospheric%20haze%2C%20abstract%20dramatic%20moody%20background%20with%20gold%20dust%20particles%2C%20rich%20shadows%2C%20elegant%20composition%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hl-hero-stage&orientation=landscape"
          alt="深色影院舞台背景，暗红帷幕与暖金聚光灯"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/75 via-background-50/80 to-background-50"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-page flex-col items-center px-4 pb-20 pt-32 text-center md:px-6 md:pb-24 md:pt-44">
        <span className="inline-flex items-center gap-2 rounded-full border border-accent-500/40 bg-background-100/70 px-4 py-1.5 text-xs font-label text-accent-400 backdrop-blur animate-fade-in">
          <i className="ri-flashlight-fill" aria-hidden="true"></i>
          本周上新 12 部 · {siteInfo.updateNote}
        </span>

        <h1 className="mt-6 max-w-3xl font-heading text-4xl font-black leading-tight text-foreground-950 animate-fade-up md:text-6xl">
          {siteInfo.name}
          <span className="mt-3 block text-lg font-semibold text-primary-400 md:text-2xl">
            黑料短剧排行榜 · 同款类似新剧一站找齐
          </span>
        </h1>

        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-foreground-700 animate-fade-up md:text-base">
          想看黑料短剧的同款类似剧？这里汇总排行榜、热门短剧与新剧推荐，按口味挑片不踩雷，
          同类好剧持续更新，帮你快速找到下一部上头的。
        </p>

        <div className="mt-9 flex w-full max-w-md flex-col items-stretch gap-3 sm:flex-row sm:justify-center">
          <Link
            to="/ranking"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-label font-medium text-background-950 transition-colors hover:bg-primary-400 cursor-pointer"
          >
            <i className="ri-trophy-line text-base" aria-hidden="true"></i>
            查看排行榜
          </Link>
          <Link
            to="/ranking?tab=new"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300/80 bg-background-100/70 px-6 py-3 text-sm font-label text-foreground-900 backdrop-blur transition-colors hover:border-primary-400 hover:text-primary-400 cursor-pointer"
          >
            <i className="ri-live-line text-base" aria-hidden="true"></i>
            找同款新剧
          </Link>
        </div>

        <dl className="mt-14 grid w-full max-w-3xl grid-cols-2 gap-4 md:grid-cols-4">
          {siteInfo.stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-200/70 bg-background-100/70 px-4 py-5 backdrop-blur"
            >
              <dt className="text-xs font-label text-foreground-600">{stat.label}</dt>
              <dd className="mt-2 font-heading text-xl font-bold text-accent-400 md:text-2xl">{stat.value}</dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="relative border-y border-background-200/60 bg-background-100/60 py-3">
        <div className="flex w-max animate-marquee">
          {[...MARQUEE_TAGS, ...MARQUEE_TAGS].map((tag, index) => (
            <span
              key={`${tag}-${index}`}
              className="mx-4 whitespace-nowrap text-xs font-label tracking-widest text-foreground-600"
            >
              <i className="ri-price-tag-3-line mr-2 text-primary-400" aria-hidden="true"></i>
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}